// Navigation Logic
export function navigateSteps(hideStep, showStep) {
    hideStep.classList.add("hidden");
    showStep.classList.remove("hidden");
}
